import { render, staticRenderFns } from "./AppLocaleSwitch.vue?vue&type=template&id=35527646&scoped=true"
import script from "./AppLocaleSwitch.vue?vue&type=script&lang=ts"
export * from "./AppLocaleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./AppLocaleSwitch.vue?vue&type=style&index=0&id=35527646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_css-loader@6.8.1_w_ce42a89a63fed7fe3b0df6fbe65086c7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35527646",
  null
  
)

export default component.exports